import { ConnectionHandler } from "relay-runtime"

export const PREVENTION_PROGRAMS_CONNECTION_KEY = "PatientPreventionProgramsConnection_preventionPrograms"

export const getPreventionProgramsConnectionId = (patientId: string) =>
  ConnectionHandler.getConnectionID(patientId, PREVENTION_PROGRAMS_CONNECTION_KEY)
